module.exports = "<section class=\"TopPanel\">\n  <div class=\"TopPanel-content\" ng-transclude></div>\n  <a class=\"TopPanel-close\" ng-click=\"close(true)\"></a>\n</section>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/common/top_panel/top_panel.html
// module id = 343
// module chunks = 24